import domReady from '@roots/sage/client/dom-ready';
import SplideSlider from './components/SplideSlider.js';

Alpine.data('SplideSlider', SplideSlider);

domReady(async () => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('scroll')) {
        const elementId = urlParams.get('scroll');
        const element = document.getElementById(elementId);
        if (element) {
            element.scrollIntoView({behavior: 'smooth'});
        }
    }

    document.addEventListener('scrollToElement', function (event) {
        const elementId = event.detail.elementId || 'form-result';
        const element = document.querySelector('#' + elementId);
        if (element) {
            element.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    });

    // let tawkChatInitialized = false;
    // const loadTawkChat = () => {
    //     if (!tawkChatInitialized) {
    //         import(/* webpackChunkName: "tawkchat" */ "@scripts/components/TawkChat.js")
    //             .then(module => {
    //                 const TawkChat = module.default;
    //                 new TawkChat();
    //                 tawkChatInitialized = true;
    //             });
    //     }
    // };
    //
    // window.addEventListener('scroll', loadTawkChat, {once: true});
    // setTimeout(loadTawkChat, 5000);
});


/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) import.meta.webpackHot.accept(console.error);
